import Vue from "vue"
import Router from "vue-router"
import { publicRoute, protectedRoute } from "./config"
import NProgress from "nprogress"
import "nprogress/nprogress.css"
import * as Cookies from "js-cookie"

const routes = publicRoute.concat(protectedRoute)

Vue.use(Router)
const router = new Router({
    mode: "hash",
    linkActiveClass: "active",
    routes: routes
})
// router gards
router.beforeEach((to, from, next) => {
    const requiresAuth = to.meta.requiresAuth
    const isLoggedIn = Cookies.get("bearer_token")

    NProgress.start()
    if (requiresAuth) {
        //si la ruta requiere auntenticacion
        //si el usuario esta autenticado
        if (isLoggedIn) {
            if (isChildRoute(to.path)) {
                //si la ruta a la que se intenta acceder es una ruta anidada
                if (isParentToChildRoute(from.path, to.path) || "/" === from.path) {
                    //si intenta acceder desde la ruta padre o se recarga la pagina
                    next()
                } else {
                    //si no esta accediendo desde la ruta padre no puede navegar
                    NProgress.done()
                    next(false)
                }
            } else {
                next()
            }
        } else {
            //redirect al login
            if (from.path === "/login") {
                NProgress.done()
                next(false)
            } else {
                next("/auth")
            }
        }
    } else {
        //si la ruta no requiere auntenticacion
        if (isLoggedIn && to.path === "/login") {
            if (from.path === "/dashboard") {
                //si la ruta de donde proviene la peticion es el dashboard no se puede redireccionar al dashboard
                NProgress.done()
                next(false)
            } else {
                next("/dashboard")
            }
        } else {
            next()
        }
    }
})

router.afterEach(to => {
    NProgress.done()

    // Definiendo el título de la aplicación para cada página
    document.title = to.meta.title + " | Todocolegios"
})

//listado de todos los pares de rutas padres/hijas
const childRoutesPair = [
    { parent: "/nomencladores/campus", child: "/nomencladores/campus/seccion" },
    { parent: "/estudiante", child: "/estudiante/curso" },
    { parent: "/nomencladores/grado", child: "/nomencladores/grado/grupo" },
    { parent: "/nomencladores/ciclo", child: "/nomencladores/ciclo/tarifa" }
]

//comprobar si se va desde una ruta padre hacia la hija
const isParentToChildRoute = (from, to) => {
    return !!childRoutesPair.filter(el => el.parent === from && el.child === to).length
}

//comprobar si se es una ruta hija
const isChildRoute = route => {
    return !!childRoutesPair.filter(el => el.child === route).length
}

export default router
